import React from "react";
import { useNavigate } from "react-router-dom";
import { createHallImage, getHallList } from "adminApi/HallImagesApi/HallImage";
import { validateForm } from "utils/validation";
import { HallImagesRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/HallImageField.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import AddHallImagesForm from "./Components/AddHallImagesForm";
import useFetchAllData from "Hooks/useFetchAllData";
import useSequentialImageUpload from "Hooks/useSequentialImageUpload";

const AddHallImages = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce(
        (acc, field) => ({ ...acc, [field.name]: "" }),
        {}
    );

    const { values, errors, handleChange, handleFileChange, setErrors } = useFormChange(
        initialValues,
        HallImagesRules
    );

    const { data: roomList, loading: loadingRoomList } = useFetchAllData(getHallList);

    const { uploadImages, uploading } = useSequentialImageUpload(createHallImage);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const { hall_image, hall_imagePreview, ...rest } = formValues;
            await uploadImages({
                files: hall_image,
                fileFieldName: "hall_image",
                payload: rest,
                successMessage: "Hall images uploaded successfully",
            });
            return {
                data: { success: true, data: { message: "Hall images uploaded" } },
            };
        },
        (vals) => {
            // Copy before mutating to avoid modifying original state
            const v = { ...vals };
            delete v.hall_imagePreview;
            const err = validateForm(v, HallImagesRules);
            if (err) setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Hall Images added successfully"
    );

    return (
        <>
            {(loadingSubmit || uploading || loadingRoomList) && <Spinner isSpinner={true} />}
            <AddHallImagesForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleFileChange={handleFileChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit || uploading}
                imagePreview={values.hall_imagePreview}
                roomList={roomList || []}
            />
        </>
    );
};

export default AddHallImages;
